import { msg } from 'gt-react';
import { CurrencyCircleDollarIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../route';

const PriceListsPage = lazyRouteComponent(
  () => import('./PriceListsPage'),
  'PriceListsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/price-lists',
  staticData: {
    app: {
      nav: {
        label: msg('Price Lists', {
          context: 'sidebar nav label, Sales section',
        }),
        icon: <CurrencyCircleDollarIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 42,
      },
      access: {
        modulesAnyOf: [ProductModule.ORDER_MANAGEMENT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.PriceList }],
      },
    },
  },
  component: PriceListsPage,
  // Filters live in the URL (the Sales section convention) so a shared link
  // restores the view and the AI assistant's filter tools drive the same state.
  // Multi-value filters are comma-joined strings.
  validateSearch: z.object({
    name: z.string().optional().catch(undefined),
    sources: z.string().optional().catch(undefined),
    currencies: z.string().optional().catch(undefined),
    exception: z.enum(['with', 'without']).optional().catch(undefined),
  }),
  loader: () => ({
    crumb: msg('Price Lists', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.PriceList,
    });
  },
});
